module.exports = __webpack_public_path__ + "img/mp4.ff4537ad.png";